import { AuthUser } from '@cddng/auth-oidc-apim';

export class AuthUserDto extends AuthUser {

  isExpeditionManuelProd: boolean = false;
  isExpeditionAutoProd: boolean = false;
  isExpeditionAutoShow: boolean = false;
  isSupervisionProd: boolean = false;
  isSupervisionShow: boolean = false;
  isRechercheConsultation: boolean = false;
  isAdmin: boolean = false;

  constructor(auth?: AuthUser) {
    super();
    this.firstName = auth?.firstName ?? '';
    this.lastName = auth?.lastName ?? '';
    this.function = auth?.function ?? '';
    this.type = auth?.type ?? '';
    this.idRh = auth?.idRh ?? '';
    this.phone = auth?.phone ?? '';
    this.mobile = auth?.mobile ?? '';
    this.email = auth?.email ?? '';
    this.regateCode = auth?.regateCode ?? '';
    this.roles = auth?.roles ?? [];
  }
}
